import { Provider } from "@angular/core";
import { EVENT_MANAGER_PLUGINS } from "@angular/platform-browser";
import { CaptureEventPlguin } from "./event-managers/capture-event-manager.plguin";

export const eventManagersProviders: Provider[] = [
  {
    provide: EVENT_MANAGER_PLUGINS,
    useClass: CaptureEventPlguin,
    multi: true,
  },
];
